
const hideElement = function (element:HTMLDivElement){
  element.style.pointerEvents = 'none';
  element.style.opacity = '0';
}

const hideSelector = function(selector: string){
  const element = document.querySelector(selector) as HTMLDivElement|undefined;
  element && hideElement(element);
}
const showElement = function (element:HTMLDivElement){
  element.style.pointerEvents = 'auto';
  element.style.opacity = '1';
}
const showSelector = function (selector:string){
  const element = document.querySelector(selector) as HTMLDivElement|undefined;
  element && showElement(element);
}
const PluginFullScreen = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(onRequestFullscreen: () => void, onCancelFullscreen: () => void) {
        this.player = null;
        this.onRequestFullscreen = onRequestFullscreen;
        this.onCancelFullscreen = onCancelFullscreen;
      },
      createEl: function(el: any, player: any) {
        this.player = player;

        const hideAll = () => {

          const gallery = document.querySelector('.gallery') as HTMLDivElement;
          // 在微信的3.2.2 版本中，最大宽度750px会限制全屏内容的左侧定位，这里干掉最大宽度
          if(gallery){
            gallery.style.maxWidth = '100%';
          }

          const rootDocument = window.document.body;
          if((rootDocument.className || "").indexOf('video-fullscreen') < 0) {
            rootDocument.className = rootDocument.className + ' video-fullscreen';
          }

          hideSelector('.pendant')
          hideSelector('.all-for-gallery-switch')
          hideSelector('.all-for-commentsend.mobile')
          hideSelector('.commentlist.theme-fixed')
          hideSelector('.bottom-tab')

          if(this.onRequestFullscreen) {
            this.onRequestFullscreen(this.player);
          }
        };

        const showAll = () => {

          const gallery = document.querySelector('.gallery') as HTMLDivElement;
          if(gallery){
            gallery.style.maxWidth = '750px';
          }

          const rootDocument = window.document.body;
          rootDocument.className = (rootDocument.className || "").replace(/\s*video-fullscreen/g, '');

          showSelector('.pendant')
          showSelector('.all-for-gallery-switch')
          showSelector('.all-for-commentsend.mobile')
          showSelector('.commentlist.theme-fixed')
          showSelector('.bottom-tab')

          // 在某些机型下，全屏后再切回来，没有触发resize事件，需要手动来一下 2025-05-19
          window.dispatchEvent(new Event('resize')); 

          if(this.onCancelFullscreen) {
            this.onCancelFullscreen(this.player);
          }
        };

        // mac safari下也需要隐藏，所以索性就不做判断了，同时在里边对底部导航也做隐藏
        //if (window.isweixinweb) {
          this.player.on('requestFullScreen', hideAll);
          this.player.on('cancelFullScreen', showAll);
        //}
      }
    })
  : null;

export default PluginFullScreen;
